import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=813bbb28&scoped=true&"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=813bbb28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813bbb28",
  null
  
)

export default component.exports